import moment from 'moment';
import { getOpenRatePercent, isDraft } from '../../../campaign-utils';
export var sortByCreatedDate = function (a, b) {
    var aCreatedAt = moment(a.original.createdAt);
    var bCreatedAt = moment(b.original.createdAt);
    return aCreatedAt.isBefore(bCreatedAt) ? -1 : 1;
};
export var sortByOpenRate = function (a, b) {
    var aOpenRate = isDraft(a.original) ? -1 : getOpenRatePercent(a.original);
    var bOpenRate = isDraft(b.original) ? -1 : getOpenRatePercent(b.original);
    if (!Number.isFinite(aOpenRate)) {
        return Number.isFinite(bOpenRate) ? -1 : 0;
    }
    if (!Number.isFinite(bOpenRate)) {
        return 1;
    }
    return aOpenRate - bOpenRate;
};
